function initLivechatTrigger() {
  const chatLinks = document.querySelectorAll('.open_livechat');
  if (!chatLinks.length) return;

  chatLinks.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const shopifyChat = document.getElementById('ShopifyChat');
      if (shopifyChat && shopifyChat.shadowRoot) {
        const chatToggleButton = shopifyChat.shadowRoot.querySelector('button.chat-toggle');
        if (chatToggleButton) {
          chatToggleButton.click();
        } else {
          console.warn('Chat toggle button not found within ShopifyChat shadow DOM.');
        }
      } else {
        console.warn('ShopifyChat element or its shadowRoot not found.');
      }
    });
  });
}


// Add more functions in this to initialize them on interaction
function initializeAll() {
  initLivechatTrigger();
//   initLivechatTrigger2();  example!!
}

const events = ['scroll', 'touchstart', 'keydown', 'click'];

const runOnce = () => {
  initializeAll();
  events.forEach(evt => window.removeEventListener(evt, runOnce));
};

events.forEach(evt => {
  window.addEventListener(evt, runOnce, { once: true, passive: true });
});
